import React from 'react'

import {
  HeadingMedium,
  HeadingSmall,
  BodyText,
  CTALink,
  FadeIn,
  Panel,
  ToggleSwitch,
  Label,
} from '@pb/components'
import PropTypes from 'prop-types'

import styles from './Preferences.scss'

const PreferencesComponent: React.FC<any> = ({ isChecked, onChange, onClick }) => (
  <FadeIn className={styles.container}>
    <Panel padding="xs m">
      <HeadingMedium>
        <Label copyKey="omni.hmxklarna.todo.tab.preferences.section.heading" />
      </HeadingMedium>
    </Panel>
    <div className={styles.preferences}>
      <HeadingSmall>
        <Label copyKey="omni.hmxklarna.todo.tab.preferences.section.toggle" />
      </HeadingSmall>
      <div className={styles.monthlyInvoicesToggle}>
        <BodyText className={styles.monthlyInvoicesToggleExplanation}>
          <Label copyKey="omni.hmxklarna.todo.tab.preferences.section.explanation" />
        </BodyText>
        <ToggleSwitch
          id="preferences"
          onChange={onChange}
          checked={isChecked}
          className={styles.monthlyInvoicesToggleSwitch}
        />
      </div>
      <CTALink Tag="button" onClick={onClick} className={styles.readMore} size="small" inline>
        <Label copyKey="omni.hmxklarna.todo.tab.preferences.section.link" />
      </CTALink>
    </div>
  </FadeIn>
)

PreferencesComponent.propTypes = {
  isChecked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default PreferencesComponent
